import { PageLoading } from '@/components/page-loading'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'

export const LogLayout = () => (
  <ContentLayout menuList={[]}>
    <Suspense fallback={<PageLoading />}>
      <Outlet />
    </Suspense>
  </ContentLayout>
)
